const detailsElement = document.querySelector('.product_detail_accordion-description');
// const liElements = detailsElement ? detailsElement.querySelectorAll('li') : [];

let liElements = [];

if (detailsElement) {
  const liTagHighlights = detailsElement.querySelectorAll('li');
  const pTagHighlights = detailsElement.querySelectorAll('p');
  if (liTagHighlights.length > 0) {
    liElements = liTagHighlights;
  } else if (pTagHighlights.length > 0) {
    liElements = pTagHighlights;
  }
}

const descriptionElement = document.querySelector('.description-content');
const maxVisibleItems = 2;
let isExpanded = false;

const createButton = (text, className) => {
  const button = document.createElement('button');
  button.textContent = text;
  button?.classList.add(className);
  return button;
};

const createImageElement = () => {
  const img = document.createElement('img');
  img.src = 'https://cdn.shopify.com/s/files/1/0568/5166/0962/files/Group_432300_2.svg?v=1689584452'; 
  img?.classList.add('rotate-180');
  return img;
};

const createToggleButtons = (container, toggleElements) => {
  const showMoreButton = createButton('Read More', 'show_more_button');
  const showLessButton = createButton('Show Less', 'show_less_button');
  showLessButton.style.display = 'none';

  const imageElement = createImageElement();

  showMoreButton.addEventListener('click', () => {
    console.log("Getting")
    toggleElements();
    showMoreButton.style.display = 'none';
    showLessButton.style.display = 'block';
    imageElement?.classList.remove('rotate-180');
    isExpanded = true;
  });

  showLessButton.addEventListener('click', () => {
    toggleElements();
    showLessButton.style.display = 'none';
    showMoreButton.style.display = 'block';
    imageElement?.classList.add('rotate-180');
    isExpanded = false;
    detailsElement.scrollIntoView();
  });

  container.appendChild(imageElement);
  container.appendChild(showMoreButton);
  container.appendChild(showLessButton);
};

const handleLiElements = () => {
  for (let i = maxVisibleItems; i < liElements.length; i++) {
    liElements[i]?.classList.add('hidden');
  }

  const containerDiv = document.createElement('div');
  containerDiv?.classList.add('show_hide_btn_cont');

  const toggleLiElements = () => {
    for (let i = maxVisibleItems; i < liElements.length; i++) {
      liElements[i]?.classList.toggle('hidden');
    }
  };

  createToggleButtons(containerDiv, toggleLiElements);
  detailsElement.appendChild(containerDiv);
};

const handleTextContent = () => {
  const containerDiv = document.createElement('div');
  containerDiv?.classList.add('show_hide_btn_cont');
   descriptionElement?.parentElement?.classList.add('has-show-hide-btn');

  const toggleTextVisibility = () => {
    descriptionElement?.classList.toggle('expanded');
  };

  createToggleButtons(containerDiv, toggleTextVisibility);
  descriptionElement?.parentElement.appendChild(containerDiv);
};

if (liElements.length > 0) {
  handleLiElements();
} else {
  handleTextContent();
}










